export enum LOGIN_PAGES {
  EMAIL = 0,
  PASSWORD = 1,
  FORGOT_PASSWORD_EMAIL = 2,
  CHANGE_PASSWORD = 3,
  ACCOUNT_CONFIRMED_SCREEN = 4,
  EMAIL_SENT_SCREEN = 5,
  PASSWORD_CREATION = 6,
  LINK_EXPIRED = 7,
  ACCESS_DENIED = 8,
  SIGN_UP_SCREEN = 9,
  SIGN_UP_SCREEN_SUCCESS = 10,
}
